import { useEffect, useState, type ReactNode } from "react";
import { Search, X } from "lucide-react";

type Props = {
  search: string;
  onSearch(q: string): void;
  activeCount: number;
  onClear(): void;
  children?: ReactNode;
  placeholder?: string;
};

export function FilterBar({
  search,
  onSearch,
  activeCount,
  onClear,
  children,
  placeholder = "Pesquisar",
}: Props) {
  const [q, setQ] = useState(search);
  useEffect(() => {
    setQ(search);
  }, [search]);
  useEffect(() => {
    const t = setTimeout(() => q !== search && onSearch(q), 300);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
      <div className="input-group" style={{ maxWidth: 360 }}>
        <span className="input-group-text">
          <Search size={16} aria-hidden="true" />
        </span>
        <input
          type="search"
          className="form-control"
          aria-label="Pesquisar na lista"
          placeholder={placeholder}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      {children}
      {activeCount === 0 ? (
        <span className="badge text-bg-light">Nenhum filtro aplicado</span>
      ) : (
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClear}>
          <X size={14} aria-hidden="true" /> Limpar ({activeCount})
        </button>
      )}
    </div>
  );
}
